import React from "react";
import NoPhoto from "../../../../images/no-photo.svg";
import * as S from "./styles";
export var CategoryFilter = function CategoryFilter(_ref) {
  var values = _ref.values,
      onValueClick = _ref.onValueClick;
  return React.createElement(S.Wrapper, null, values && values.map(function (value) {
    return React.createElement(S.CategoryItem, {
      onClick: function onClick() {
        return onValueClick(value);
      },
      "aria-hidden": "true",
      className: "category-item\n              ".concat(value.selected ? "active" : ""),
      key: value.id
    }, React.createElement(S.CategoryItemImage, {
      className: "category-item__image",
      style: {
        backgroundImage: "url(".concat(value.url || NoPhoto, ")")
      }
    }, React.createElement(S.CategoryItemImageOverlay, {
      className: "category-item__image-overlay"
    })), React.createElement(S.CategoryItemTitle, {
      className: "category-item__title"
    }, value.name));
  }));
};
CategoryFilter.displayName = "CategoryFilter";